import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class ReportModel extends BaseModel {

    constructor() {
        super({
            name: "report",
            tableName: 'report',
            label: "Danh sách báo cáo",
            display_key: 'name',
            default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    class: "center",
                    label: 'Mã báo cáo',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                farm: {
                    name: 'farm',
                    type: "String",
                    custom: 'String',
                    class: "center",
                    label: 'Tên trang trại',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    refs: 'farm {id name}'
                },
                name: {
                    name: 'name',
                    type: "String",
                    class: "center",
                    label: 'Loại công việc',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                unit: {
                    name: 'unit',
                    type: "String",
                    custom: 'String',
                    class: "center",
                    label: 'Mã unit',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    refs: 'unit {id code}'
                },
                content:{
                    name: 'content',
                    type: "String",
                    class: "center",
                    label: 'Nội dung',
                },
                status: {
                    name: "status",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Tình trạng xử lý",
                    class: "center",
                    options: [
                        {value : 1 , label: "Đã xử lý"},
                        {value : 2 , label : "Chưa xử lý"},
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                users: {
                    name: 'users',
                    type: "String",
                    custom: 'String',
                    class: "center",
                    label: 'Người gửi BC',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    refs: 'users {fullname}'
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    class: "center",
                    label: 'Ngày báo cáo',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },
                work: {
                    refs: 'work {id name type_work{id name}}',
                    display: false
                }
            },
        )
    }

}